import { isWebMCPAvailable, } from "./global.js";
/**
 * Wraps a plain-value WebMCP result into the `{ content: [...] }` shape.
 */
export function text(value) {
    return { content: [{ type: "text", text: value }] };
}
export function json(value) {
    return { content: [{ type: "text", text: JSON.stringify(value) }] };
}
export function refusal(reason) {
    return { content: [{ type: "text", text: JSON.stringify({ refused: true, reason }) }], isError: true };
}
export function defineTool(def) {
    return {
        ...def,
        async call(input) {
            return def.handler(input);
        },
        toWebMCP() {
            return {
                name: def.name,
                description: def.description,
                inputSchema: def.inputSchema,
                annotations: def.annotations,
                async execute(input) {
                    try {
                        const result = await def.handler(input);
                        return json(result);
                    }
                    catch (err) {
                        return refusal(err instanceof Error ? err.message : String(err));
                    }
                },
            };
        },
    };
}
/**
 * Registers a batch of tools with `document.modelContext`. No-ops cleanly
 * (and synchronously) when WebMCP is unavailable, so callers never need to
 * branch on `isWebMCPAvailable()` themselves.
 */
export function registerTools(tools, options = {}) {
    if (!isWebMCPAvailable())
        return;
    const modelContext = document.modelContext;
    const registerOptions = options.signal ? { signal: options.signal } : undefined;
    for (const tool of tools) {
        const raw = tool.toWebMCP();
        const execute = raw.execute;
        raw.execute = async (input) => {
            const start = performance.now();
            try {
                const result = await execute(input);
                options.onInvoke?.({
                    toolName: tool.name,
                    input,
                    output: result,
                    durationMs: performance.now() - start,
                });
                return result;
            }
            catch (err) {
                const message = err instanceof Error ? err.message : String(err);
                options.onInvoke?.({
                    toolName: tool.name,
                    input,
                    output: undefined,
                    error: message,
                    durationMs: performance.now() - start,
                });
                throw err;
            }
        };
        modelContext.registerTool(raw, registerOptions);
    }
}
export { isWebMCPAvailable };
